import Enum from './enum'

class UserRole extends Enum
{
  constructor(value) {
    super(value);
  }
}

UserRole.init({
  ORGANIZER: 'Organizer',
  MAIN_ORGANIZER: 'MainOrganizer',
  COMMISSION_MEMBER: 'CommissionMember',
  COMMISSION_MEMBER_NONE: 'None',
  ADMIN: 'Administrator',
  PARTICIPANT: 'Participant',
  MAIN_PARTICIPANT: 'MainParticipant'
},
{
  ORGANIZER: 'user-role.organizer',
  MAIN_ORGANIZER: 'user-role.main-organizer',
  COMMISSION_MEMBER: 'user-role.commission-member',
  COMMISSION_MEMBER_NONE: 'user-role.commission-member',
  ADMIN: 'user-role.admin',
  PARTICIPANT: 'user-role.participant',
  MAIN_PARTICIPANT: 'user-role.main-participant'
});

export default UserRole;
